import React, { FC, useCallback } from 'react'
import { Button } from 'transfix-ui/components/Button'
import { useGlobalToast } from 'transfix-ui/components/Toast'
import Box from 'transfix-ui/core/Box'
import { useResendEdi214Mutation } from './graphql/ResendEdi214Mutation'

interface IResendEdi214ButtonProps {
  shipmentId: string
}

export const ResendEdi214Button: FC<IResendEdi214ButtonProps> = ({ shipmentId }) => {
  const [resendEdi214] = useResendEdi214Mutation()
  const { openToast } = useGlobalToast()

  const resendEdiHandler = useCallback(async () => {
    try {
      const { errors } = await resendEdi214({
        variables: {
          input: {
            shipmentId,
          },
        },
      })

      const [error] = errors || []

      if (error) {
        throw error
      }

      openToast({
        toastMessage: 'Resending EDI 214 scheduled.',
      })
    } catch (error) {
      openToast({
        toastMessage: error?.message,
        toastType: 'alert',
      })
    }
  }, [openToast, resendEdi214, shipmentId])

  return (
    <Box mr={1}>
      <Button onClick={resendEdiHandler} color='tertiary' data-test='resend-214'>
        Resend EDI
      </Button>
    </Box>
  )
}

export default ResendEdi214Button
